/**All Incidents data handling functionlity is there in this component */

import React, { useState, useEffect } from "react";
import "./AllIncidentsTable.css";
import { t } from "i18next";
import {
  Deleteicon,
  EditConvgIcon,
  Viewicon,
} from "../../../../Components/IconComponents";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Table from "../../../../Components/UiComponents/Table/Table";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import {
  deleteIncidentByID,
  getTaskConfigsURL,
  getbarches,
  getThemeURL,
  getallBanksByRole,
  fetchAllIncidentsByRole,
} from "../../../../Services/EndPoints";
import {
  deleteDataById,
  getData,
  postDataWithBody,
} from "../../../../Services/Services";
import { AllIncidentsConfig } from "../../../../JsonData/AllIncidentsConfig";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import { useDispatch } from "react-redux";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { Search } from "lucide-react";

const AllIncidentsTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Pagination and filter state
  // eslint-disable-next-line no-unused-vars
  const [itemsPerPage, setItemsPerPage] = useState(10);
  //const [activeView, setActiveView] = useState("List view");
  const [activeCategory, setActiveCategory] = useState("All Incidents");
  const [searchQuery, setSearchQuery] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [statusFilter, setStatusFilter] = useState("All");

  // Updated filter states - using IDs instead of names
  const [selectedBankId, setSelectedBankId] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState("");

  // Role-based state
  const [userRole, setUserRole] = useState("");
  const [isAdmin, setIsAdmin] = useState(null);
  const [userBankId, setUserBankId] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });

  // Data state
  // eslint-disable-next-line no-unused-vars
  const [searchData, setSearchData] = useState([]);
  const [incidentsData, setIncidentsData] = useState([]);
  const [banksList, setBanksList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [incidentCategories, setIncidentCategories] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [sourceList, setSourceList] = useState([]);
  const [filteredIncidents, setFilteredIncidents] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [userId, setUserId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const allIncidents = [...incidentsData];

  const [userPermissions, setUserPermissions] = useState({
    canView: false,
    canEdit: false,
    canDelete: false,
  });

  // Initialize component data on mount
  useEffect(() => {
    fetchUserProfile();
    getSourceValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch user profile and set userId and role
  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        const userProfile = response[0];
        setUserId(userProfile.id);
        setUserRole(userProfile.role_name || "");
        setUserBankId(userProfile.bank_id || "");
        setIsAdmin(userProfile.is_admin || null);

        const permissions = parseUserPermissions(userProfile.web_permissions);
        setUserPermissions(permissions);

        // Fetch banks based on user role
        fetchBanks(userProfile);
        if (userProfile.is_admin === true && userProfile.bank_id) {
          fetchBranches(userProfile.bank_id);
          setSelectedBankId(userProfile.bank_id); // Auto-select their bank
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  useEffect(() => {
    if (selectedBankId && branches.length > 0) {
      const filtered = branches.filter((branch) => {
        // Handle different possible branch data structures
        const branchBankId = branch.bankId || branch.bank_id || branch.bankID;
        // eslint-disable-next-line eqeqeq
        return branchBankId == selectedBankId;
      });
      console.log("Filtered branches for bank", selectedBankId, ":", filtered); // Debug log
      setFilteredBranches(filtered);
      // Reset branch selection when bank changes
      setSelectedBranchId("");
    } else {
      setFilteredBranches([]);
      setSelectedBranchId("");
    }
  }, [selectedBankId, branches]);

  const applyFilters = () => {
    let filtered = [...allIncidents];

    if (activeCategory !== "All Incidents") {
      filtered = filtered.filter((item) => {
        const itemSeverity = item.severityLevel?.toUpperCase() || "";
        const filterCategory = activeCategory.toUpperCase();
        return itemSeverity === filterCategory;
      });
    }

    if (statusFilter !== "All") {
      filtered = filtered.filter((item) => item.status === statusFilter);
    }

    // Bank filter - using ID comparison
    if (selectedBankId) {
      // eslint-disable-next-line eqeqeq
      filtered = filtered.filter((item) => item.bankId == selectedBankId);
    } else if (isAdmin && userBankId) {
      // For HO users, automatically filter by their bank
      // eslint-disable-next-line eqeqeq
      filtered = filtered.filter((item) => item.bankId == userBankId);
    }

    // Branch filter - using ID comparison
    if (selectedBranchId) {
      // eslint-disable-next-line eqeqeq
      filtered = filtered.filter((item) => item.branchId == selectedBranchId);
    }

    // ... rest of your filter logic
    if (dateRange.startDate && dateRange.endDate) {
      const startDate = new Date(dateRange.startDate);
      const endDate = new Date(dateRange.endDate);
      endDate.setHours(23, 59, 59);

      filtered = filtered.filter((item) => {
        const reportedDate = new Date(item.reportedDate);
        return reportedDate >= startDate && reportedDate <= endDate;
      });
    }

    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          (item.id && item.id.toString().toLowerCase().includes(query)) ||
          (item.incidentId && item.incidentId.toLowerCase().includes(query)) ||
          (item.eventType && item.eventType.toLowerCase().includes(query)) ||
          (item.incidentName &&
            item.incidentName.toLowerCase().includes(query)) ||
          (item.description &&
            item.description.toLowerCase().includes(query)) ||
          (item.reporterName &&
            item.reporterName.toLowerCase().includes(query)) ||
          (item.affectedServices &&
            item.affectedServices.toLowerCase().includes(query))
      );
    }

    setFilteredIncidents(filtered);
    sendDataToCentralStore(filtered);
    setRowCount(filtered.length);
  };

  const parseUserPermissions = (webPermissions) => {
    if (!webPermissions) {
      return { canView: false, canEdit: false, canDelete: false };
    }

    const permissions = webPermissions
      .split(",")
      .map((p) => p.trim().toUpperCase());

    return {
      canView: permissions.includes("V"),
      canEdit: permissions.includes("E"),
      canDelete: permissions.includes("D"),
    };
  };

  // Apply filters when filter dependencies change
  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeCategory,
    statusFilter,
    searchQuery,
    selectedBankId,
    selectedBranchId,
    dateRange,
    itemsPerPage,
    incidentsData,
  ]);

  // Render status badge with appropriate styling
  const renderStatusBadge = (status) => {
    let backgroundColor = "";
    let dotColor = "";
    switch (status) {
      case "Draft":
        backgroundColor = "rgba(101, 123, 124, 0.5)";
        dotColor = "#576666ff";
        break;
      case "Open":
        backgroundColor = "rgba(233, 80, 96, 0.5)";
        dotColor = "#E95060";
        break;
      case "Closed":
        backgroundColor = "rgba(0, 191, 40, 0.5)";
        dotColor = "#00BF28";
        break;
      case "In Progress":
        backgroundColor = "rgba(255, 161, 0, 0.5)";
        dotColor = "#FFA100";
        break;
      default:
        backgroundColor = "rgba(128, 128, 128, 0.5)";
        dotColor = "#808080";
    }

    return (
      <div className="status-badge-container" style={{ position: "relative" }}>
        <div
          className="status-badge"
          style={{
            backgroundColor: backgroundColor,
            color: "black",
            borderRadius: "5px",
            padding: "4px 16px 4px 20px",
            display: "inline-block",
            width: "107px",
            height: "28px",
            lineHeight: "20px",
          }}
        >
          <div
            className="status-dot"
            style={{
              backgroundColor: dotColor,
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              position: "absolute",
              left: "8px",
              top: "10px",
            }}
          ></div>
          {status}
        </div>
      </div>
    );
  };

  // Render category with appropriate color coding
  const renderCategory = (category) => {
    if (!category) return "NA";
    let textColor = "";
    switch (category.toUpperCase()) {
      case "CRITICAL":
      case "HIGH":
        textColor = "#F16A87";
        break;
      case "MEDIUM":
        textColor = "#FFA100";
        break;
      case "LOW":
        textColor = "#40BAC2";
        break;
      default:
        textColor = "#808080";
    }

    return (
      <span style={{ color: textColor, fontWeight: "bold" }}>{category}</span>
    );
  };

  // Navigate to event details page
  const navigateToEventDetails = (incident) => {
    navigate("/incidents/event-type-details", {
      state: {
        data: incident,
      },
    });
  };

  // Status mapping for numerical values
  const statusMap = {
    749: "Open",
    750: "In Progress",
    752: "Closed",
  };

  // Format date to DD-MM-YY HH:MM format
  const formatDateToDDMMYYTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, "0");
    const mins = String(date.getMinutes()).padStart(2, "0");
    return `${dd}-${mm}-${yy} ${hours}:${mins}`;
  };

  // Send processed data to central Redux store
  const sendDataToCentralStore = (data) => {
    const columns = AllIncidentsConfig;

    if (data && data.length > 0) {
      const processedData = data.map((item) => ({
        ...item,
        event_status: statusMap[item.event_status] || item.event_status,
        reportedDate: formatDateToDDMMYYTime(item.reportedDate),
        created_on: formatDateToDDMMYYTime(item.created_on),
        incidentDateAndTime: formatDateToDDMMYYTime(item.incidentDateAndTime),
      }));

      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, processedData),
        })
      );
    } else {
      dispatch(
        setTableData({
          columns,
          tableData: [],
        })
      );
    }
  };

  // Define table columns configuration
  const columns = React.useMemo(
    () => [
      {
        Header: t("Incident ID"),
        accessor: "incidentId",
        disableSortBy: false,
        Cell: ({ value, row }) => {
          if (value) {
            return (
              <span
                className="clickable-link"
                onClick={() => navigateToEventDetails(row.original)}
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                title={`Click to add or view event details`}
              >
                {value}
              </span>
            );
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("Incident Name"),
        accessor: "incidentName",
        disableSortBy: true,
        Cell: ({ value, row }) => {
          if (value) {
            return (
              <span
                className="clickable-link"
                onClick={() => navigateToEventDetails(row.original)}
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                title={`Click to add or view event details`}
              >
                {value}
              </span>
            );
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("Bank/Branch - Location"),
        accessor: (row) => ({
          name: row.branchName || row.bankName, // pick one
          lat: row.latitude,
          lng: row.longitude,
        }),
        disableSortBy: true,
        Cell: ({ value }) => {
          const [locationName, setLocationName] = React.useState("Loading...");

          React.useEffect(() => {
            let isMounted = true;

            const fetchLocation = async () => {
              try {
                const response = await fetch(
                  `https://nominatim.openstreetmap.org/reverse?lat=${value.lat}&lon=${value.lng}&format=json`
                );
                const data = await response.json();
                if (isMounted) {
                  setLocationName(data.display_name || "NA");
                }
              } catch (err) {
                if (isMounted) {
                  setLocationName("Error loading location");
                }
              }
            };

            fetchLocation();

            return () => {
              isMounted = false;
            };
          }, [value.lat, value.lng]);

          return (
            <span>
              {value.name} - {locationName}
            </span>
          );
        },
      },

      {
        Header: t("Source"),
        accessor: "sourceName",
        disableSortBy: true,
      },
      {
        Header: t("Affected Services"),
        accessor: "affectedServices",
        disableSortBy: true,
        Cell: ({ value }) => value || "NA",
      },
      {
        Header: t("Incident Date & Time"),
        accessor: "incidentDateAndTime",
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value) return "NA";

          const date = new Date(value);

          const formattedDate = date
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-");

          const formattedTime = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          return `${formattedDate} ${formattedTime}`;
        },
      },
      {
        Header: t("SLA Target"),
        accessor: "slaTarget",
        disableSortBy: true,
        Cell: ({ value }) => value || "NA",
      },
      {
        Header: t("Severity"),
        accessor: "severityLevel",
        disableSortBy: true,
        Cell: ({ value }) => renderCategory(value),
      },
      {
        Header: t("Status"),
        accessor: "event_status",
        disableSortBy: false,
        Cell: ({ value }) => {
          let status = "Draft";

          if (value === 749) {
            status = "Open";
          } else if (value === 750) {
            status = "In Progress";
          } else if (value === 752) {
            status = "Closed";
          }

          return renderStatusBadge(status);
        },
      },
      ...(userPermissions.canView ||
      userPermissions.canEdit ||
      userPermissions.canDelete
        ? [
            {
              Header: t("sopinstancelist.action"),
              disableSortBy: true,
              Cell: (props) => {
                const [isdelete, setIsdelete] = useState(false);
                const deletePopUp = () => setIsdelete(!isdelete);

                const deleteTableDataById = async (id) => {
                  let selectedId = id;
                  try {
                    var res = await deleteDataById(
                      deleteIncidentByID,
                      selectedId
                    );
                    if (res?.status === "success") {
                      setIsdelete(false);
                      await getAllIncidents();
                      toast.success(res.msg || t("delete_success_message"), {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                      });
                    } else {
                      toast.error(res.msg || t("delete_failure_message"), {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                      });
                    }
                  } catch (error) {
                    console.error("Error deleting incident:", error);
                  }
                };

                const isEventCreated = props.row.original.is_event_created;

                return (
                  <div
                    className="usertable__actionsicon"
                    style={{ display: "flex", gap: "5px" }}
                  >
                    {/* View Incident */}
                    {userPermissions.canView && (
                      <span
                        onClick={() =>
                          navigate("/incidents/View-incidents", {
                            state: { data: props.row.original },
                            device_type: true,
                          })
                        }
                      >
                        <Viewicon className="cursor-pointer me-2" />
                      </span>
                    )}

                    {/* Edit Incident */}
                    {userPermissions.canEdit && (
                      <span
                        onClick={() => {
                          if (!isEventCreated) {
                            navigate("../create-incident", {
                              state: { data: props.row.original, edit: true },
                            });
                          }
                        }}
                        style={{
                          pointerEvents: isEventCreated ? "none" : "auto",
                          opacity: isEventCreated ? 0.5 : 1,
                        }}
                      >
                        <EditConvgIcon className="cursor-pointer" />
                      </span>
                    )}

                    {/* Delete Incident */}
                    {userPermissions.canDelete && (
                      <span
                        onClick={() => {
                          if (!isEventCreated) deletePopUp();
                        }}
                        style={{
                          pointerEvents: isEventCreated ? "none" : "auto",
                          opacity: isEventCreated ? 0.5 : 1,
                        }}
                      >
                        <Deleteicon className="cursor-pointer" />
                      </span>
                    )}

                    {isdelete && (
                      <Confirmpopup
                        className="DeltePopup"
                        show={isdelete}
                        title={t("deletepopuptext")}
                        message={t("deletepopupmessage")}
                        handleToggle={deletePopUp}
                        row={props.row}
                        name={props.row.original.title}
                        deleteRow={deleteTableDataById}
                        cancel={t("cancelbutton")}
                        action={t("actionbutton")}
                      />
                    )}
                  </div>
                );
              },
            },
          ]
        : []),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, navigate, userPermissions]
  );

  // Fetch incidents data once userId is available
  useEffect(() => {
    if (userId) {
      getAllIncidents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // Initialize data fetching on component mount
  useEffect(() => {
    fetchIncidentDetails();
    fetchSourceDetails();
    fetchBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Create payload based on user profile
  const createPayload = (profile) => {
    let admin_role;

    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  // Fetch banks data based on user role
  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    }
  };
  const fetchBranches = async (bankId = "") => {
    try {
      // For HO users, use their bank_id if no bankId provided
      let targetBankId = bankId;
      if (!targetBankId && isAdmin && userBankId) {
        targetBankId = userBankId;
      }

      const url = targetBankId
        ? getbarches.replace("ID", targetBankId)
        : getbarches.replace("ID", "0");
      const response = await getData(url);

      // Handle different possible response structures
      let branchesData = [];
      if (Array.isArray(response)) {
        branchesData = response;
      } else if (response && typeof response === "object") {
        branchesData =
          response.data || response.branches || response.result || [];
      }

      console.log("Fetched branches for bank:", targetBankId, branchesData);
      setBranches(branchesData || []);

      // For HO users, automatically set filtered branches
      if (isAdmin) {
        setFilteredBranches(branchesData || []);
      } else if (targetBankId) {
        // For SUPER ADMIN, filter branches by selected bank
        const filtered = branchesData.filter((branch) => {
          const branchBankId = branch.bankId || branch.bank_id || branch.bankID;
          // eslint-disable-next-line eqeqeq
          return branchBankId == targetBankId;
        });
        setFilteredBranches(filtered);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranches([]);
      setFilteredBranches([]);
    }
  };

  // Enrich incidents data with additional information when all data is loaded
  useEffect(() => {
    if (
      incidentsData.length > 0 &&
      banksList.length > 0 &&
      branches.length > 0 &&
      incidentCategories.length > 0
    ) {
      const enriched = incidentsData.map((incident) => {
        const bank =
          banksList.find((bank) => bank.id === incident.bankId) || {};

        const branch =
          branches.find((branch) => {
            const branchId = branch.id || branch.branchId;
            return branchId === incident.branchId;
          }) || {};

        const category =
          incidentCategories.find(
            (cat) => cat.id === incident.incidentCategoryId
          ) || {};

        return {
          ...incident,
          bankName: bank.name || bank.bankName || "N/A",
          branchName: branch.name || branch.branchName || "N/A",
          categoryName: category.category_name || "N/A",
          status: incident.status || "Draft",
        };
      });

      setFilteredIncidents(enriched);
      setRowCount(enriched.length);
      applyFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentsData, banksList, branches, incidentCategories]);
  // Updated getAllIncidents function with role-based payload
  const getAllIncidents = async () => {
    try {
      // Get user profile to determine role and construct payload
      const userProfile = await getData(getThemeURL);

      if (
        !userProfile ||
        !Array.isArray(userProfile) ||
        userProfile.length === 0
      ) {
        toast.error("Failed to fetch user profile", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }

      const user = userProfile[0];

      // Construct payload based on user role
      const payload = createIncidentPayload(user);

      // Fetch incidents with role-based payload
      const sopMasterList = await postDataWithBody(
        fetchAllIncidentsByRole,
        payload,
        {}
      );

      let sortedList = Array.isArray(sopMasterList)
        ? sopMasterList.sort((a, b) => {
            return new Date(b.created_on) - new Date(a.created_on);
          })
        : [];

      setIncidentsData(sortedList);
      setRowCount(sortedList.length);
    } catch (error) {
      console.error("Error fetching incidents:", error);
      toast.error("Failed to load incidents data", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  // Helper function to create role-based payload for incidents
  const createIncidentPayload = (userProfile) => {
    const { is_admin, role_name, bank_id, branch_id, id: userId } = userProfile;

    // SUPER ADMIN role
    if (role_name === "SUPER ADMIN") {
      return {
        admin_role: "SA",
        bank_id: null,
        branch_id: null,
        user_id: null,
      };
    }

    // HO role
    if (is_admin === true) {
      return {
        admin_role: "HO",
        bank_id: bank_id || null,
        branch_id: null,
        userId: userId || null,
      };
    }

    // For other roles, determine based on bank_id and branch_id presence
    if (bank_id && branch_id) {
      // BRANCH_USER - has both bank_id and branch_id
      return {
        admin_role: "BRANCH_USER",
        bank_id: bank_id,
        branch_id: branch_id,
        userId: userId || null,
      };
    } else if (bank_id && !branch_id) {
      // BANK_USER - has only bank_id, no branch_id
      return {
        admin_role: "BANK_USER",
        bank_id: bank_id,
        branch_id: null,
        userId: userId || null,
      };
    }

    // Default fallback (shouldn't happen in normal cases)
    return {
      admin_role: "U",
      bank_id: bank_id || null,
      branch_id: branch_id || null,
      userId: userId || null,
    };
  };

  // Fetch incident category details
  const fetchIncidentDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["INCDNT_CAT"],
        {}
      );

      if (response && Array.isArray(response)) {
        setIncidentCategories(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  // Fetch source system details
  const fetchSourceDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["BRCH_SRC_SYS_ORG"],
        {}
      );

      if (response && Array.isArray(response)) {
        setSourceList(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  // Get source value for incidents
  const getSourceValue = () => {
    return filteredIncidents.map((incident) => {
      const source = incidentCategories.find(
        (item) => item.id === incident.incidentCategoryId
      );
      return source ? source.value : "NA";
    });
  };

  // Filter incidents by category
  const filterByCategory = (category) => {
    setActiveCategory(category);
  };

  // Handle search input change
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle bank change
  const handleBankChange = (e) => {
    const bankId = e.target.value;
    setSelectedBankId(bankId);

    // Fetch branches for the selected bank
    if (bankId) {
      fetchBranches(bankId);
    } else {
      setFilteredBranches([]);
      setSelectedBranchId("");
    }
  };

  // Handle branch change
  const handleBranchChange = (e) => {
    setSelectedBranchId(e.target.value);
  };

  // Determine which filters to show based on user role
  const shouldShowBankFilter = userRole === "SUPER ADMIN";
  const shouldShowBranchFilter = userRole === "SUPER ADMIN" || isAdmin;

  const formElementStyle = {
    height: "33px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
  };

  return (
    <>
      <div className="header-section bg-white mb-2 rounded p-2"></div>

      <div
        className="main-content bg-white rounded"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          className="filter-section p-3"
          style={{ flexShrink: 0, marginLeft: "10px" }}
        >
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="category-filters d-flex mb-2 me-2">
              <button
                className={`category-btn ${
                  activeCategory === "All Incidents" ? "active" : ""
                }`}
                onClick={() => filterByCategory("All Incidents")}
              >
                All Incidents
              </button>
              <button
                className={`category-btn ${
                  activeCategory === "Critical" ? "active" : ""
                }`}
                onClick={() => filterByCategory("Critical")}
              >
                Critical
              </button>
              <button
                className={`category-btn ${
                  activeCategory === "HIGH" ? "active" : ""
                }`}
                onClick={() => filterByCategory("HIGH")}
              >
                High
              </button>
              <button
                className={`category-btn ${
                  activeCategory === "MEDIUM" ? "active" : ""
                }`}
                onClick={() => filterByCategory("MEDIUM")}
              >
                Medium
              </button>
              <button
                className={`category-btn ${
                  activeCategory === "LOW" ? "active" : ""
                }`}
                onClick={() => filterByCategory("LOW")}
              >
                Low
              </button>

              {/* Bank dropdown - only show for SUPER ADMIN */}
              {shouldShowBankFilter && (
                <div className="filter-dropdown">
                  <select
                    className="form-select"
                    value={selectedBankId}
                    onChange={handleBankChange}
                    style={{
                      ...formElementStyle,
                      width: "148px",
                    }}
                  >
                    <option value="">All Banks</option>
                    {banksList.map((bank) => (
                      <option key={bank.id} value={bank.id}>
                        {bank.name || bank.bankName}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Branch dropdown - show for SUPER ADMIN and HO */}
              {shouldShowBranchFilter && (
                <div className="filter-dropdown">
                  <select
                    className="form-select"
                    value={selectedBranchId}
                    onChange={handleBranchChange}
                    style={{
                      ...formElementStyle,
                      width: "148px",
                    }}
                    disabled={!selectedBankId && userRole === "SUPER ADMIN"}
                  >
                    <option value="">All Branches</option>
                    {filteredBranches.map((branch) => {
                      // Handle different possible branch data structures
                      const branchId = branch.id || branch.branchId;
                      const branchName =
                        branch.name || branch.branchName || branch.branch_name;

                      return (
                        <option key={branchId} value={branchId}>
                          {branchName || `Branch ${branchId}`}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}
            </div>

            <div
              className="search-container ms-auto mb-2"
              style={{
                width: windowWidth < 768 ? "100%" : "300px",
                marginLeft: "auto",
              }}
            >
              <form
                className="d-flex align-items-center bg-white rounded-2 shadow-sm"
                style={{ height: "36px", marginLeft: "45px" }}
              >
                <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearch}
                  className="flex-grow-1"
                  style={{
                    fontSize: "0.8rem",
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                    background: "transparent",
                    width: "100%",
                    height: "100%",
                    padding: "0 10px",
                  }}
                />
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 10px",
                  }}
                >
                  <Search size={14} color="#1a7a73" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="table-section"
        style={{
          flex: 1,
          overflow: "auto",
          padding: "0 10px 10px 10px",
          marginTop: "-30px",
        }}
      >
        <Table
          data={filteredIncidents}
          title=""
          showFilter={false}
          setSearchData={setSearchData}
          columns={columns}
          numberOfRows={itemsPerPage}
          showExport={false}
          showReset={false}
          onExpand={false}
          showSearch={false}
          isHeaderFixed={true}
          rowCount={rowCount}
          headerTableHeadStyle={{
            background: "#1a7a73",
            color: "#FFFFFF",
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "20px",
            position: "sticky",
            top: 0,
            zIndex: 1000,
          }}
          tableStyle={{
            border: "1px solid #f0f0f0",
            borderRadius: "0 0 12px 12px",
            padding: "0px",
            width: "100%",
          }}
        />
      </div>
    </>
  );
};

export default AllIncidentsTable;
